export const SELECT_ALL_ID = "selected_all";
export const TRANSLATION_PREFIX = "si.lead_gen_filters.employeeHeadcount";
export const PLUS_SUFFIX = "plus";
